import React from 'react';
import Plugin, { PluginProps } from '../Plugin';
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
} from '@chakra-ui/react';

const ModalBlock = (props: PluginProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { content } = props;
  const contentData = content.data;
  const header_text = content?.data?.header_text;
  const button_text = content?.data?.button_text;
  const size = contentData.size;
  const width = contentData.width;
  const color_scheme = contentData.color_scheme;

  return (
    <>
      <Button onClick={onOpen}>{button_text}</Button>

      <Modal
        isOpen={isOpen}
        size={width == null ? size : undefined}
        colorScheme={color_scheme}
        onClose={onClose}
      >
        <ModalOverlay />
        <ModalContent>
          {header_text && <ModalHeader>{header_text}</ModalHeader>}
          <ModalCloseButton />
          <ModalBody width={width}>
            {content.children.map((child, index) => {
              return <Plugin key={index} {...props} content={child} />;
            })}
          </ModalBody>

          {/* <ModalFooter>
            <Button colorScheme='blue' mr={3} onClick={onClose}>
              Close
            </Button>
            <Button variant='ghost'>Secondary Action</Button>
          </ModalFooter> */}
        </ModalContent>
      </Modal>
    </>
  );
};

export default ModalBlock;
